import React, { Component } from "react";

import { Form } from 'react-bootstrap';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {Typeahead} from 'react-bootstrap-typeahead';

//Services
import {NotificationService} from '../Services/NotificationService';
import {UserService} from '../Services/UserService';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { withStyles } from "@material-ui/core";


const styles = theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    }, 
    margin: {
        margin: theme.spacing(1),
    },
});

class Notification extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modal: { body: '', title: ''},
            agentList: [],
            selectedAgent: null
        };

        this.sendNotification = this.sendNotification.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount(){
        this.props.setTitle('Notifications')
        UserService.getAgentList()
        .then((data) => {
            console.log(data);
            this.setState({agentList: data.users});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    handleChange(e) {
        e.preventDefault();
        let change = this.state.modal;
        change[e.target.name] = e.target.value;
        this.setState({modal: change});
    }

    sendNotification(e){
        e.preventDefault();
        let modal = this.state.modal;
        if(this.state.selectedAgent && modal.title.length > 0 && modal.body.length > 0){
            NotificationService.sendNotification(this.state.selectedAgent.id, modal.title, modal.body)
            .then((data) => {
                console.log(data);
                if(data.success > 0){
                    this.props.showSnackBar(`Sent notification to ${this.state.selectedAgent.name}`, 'success');
                    this.setState({modal: { body: '', title: ''}});
                } else {
                    throw new Error("Failed to send notification");
                }
            })
            .catch((error) => {
                this.props.showSnackBar(`Failed to send notification to ${this.state.selectedAgent.name}. Please try again.`, 'error');
            });
        }
    }

    render() {
        return (
            <div className="Home" style={{marginTop: 32}}>
                <Paper style={{width: "100%", marginTop: "10pt", maxWidth: '100%', paddingTop : '10px', paddingBottom: '10px', paddingLeft: "5px", paddingRight: "25px", display: 'inline-block'}}>
                    <h3>Send notification to Agents</h3>
                    <Form horizontal onSubmit={this.sendNotification}>
                        <div style={{marginLeft: '9px', marginRight: '-8px'}}>
                            <Typeahead
                                id="typeahead-id-notifications"
                                onChange={(selected) => {
                                    this.setState({ "selectedAgent": selected[0] });
                                }}
                                options={this.state.agentList}
                                labelKey="name"
                                placeholder="Choose a Agent"
                                clearButton
                                defaultSelected={
                                    this.state.agentList.filter((agent) => agent.id === this.state.modal.agent_id)
                                }
                                style={{marginLeft: '5px'}}
                                />
                        </div>
                        <TextField
                            id="title"
                            fullWidth
                            className={this.props.classes.textField}
                            variant="outlined"
                            label="Title"
                            margin="normal"
                            value={this.state.modal.title}
                            name="title"
                            onChange={this.handleChange}
                            type="text"
                            required />
                        <TextField
                            id="body"
                            fullWidth
                            className={this.props.classes.textField}
                            variant="outlined"
                            label="Message"
                            margin="normal"
                            value={this.state.modal.body}
                            name="body"
                            onChange={this.handleChange}
                            type="text"
                            required />
                        <Button type="submit" variant="contained" size="large" color="primary"  onClick={this.sendNotification} >Send</Button>
                    </Form>
                </Paper>
            </div>
        );
    }
}

export default withStyles(styles)(Notification);